module.exports = __webpack_public_path__ + "static/media/avatar.40f5e523.svg";